// extracted by mini-css-extract-plugin
module.exports = {"MarketplaceItemActions":"MarketplaceItemActions_MarketplaceItemActions__lrHq1","SupplierProductAdminMenu":"MarketplaceItemActions_SupplierProductAdminMenu__3Z-sr"};